import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, saveAuth } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { ADMIN } from '@/constants/testIds';
import { toast } from 'sonner';
import { ClubMark } from '@/components/PublicShell';

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/admin/login', { email, password });
      saveAuth(data.access_token, data.admin);
      toast.success(`Welcome back, ${data.admin.name || data.admin.email}`);
      nav('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={ADMIN.loginPage} className="min-h-screen bg-[hsl(var(--background))]  flex flex-col items-center justify-center px-4 py-12">
      <div className="mb-8">
        <ClubMark />
      </div>
      <Card className="w-full max-w-md rounded-2xl p-8 bg-[hsl(var(--card))] border-border shadow-[0_10px_40px_rgba(30,68,51,0.08)]">
        <div className="mb-6">
          <p className="text-xs uppercase  text-muted-foreground">Stable Office</p>
          <h1 className="mt-1 font-extrabold text-2xl font-semibold">Sign in to manage the herd</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="grid gap-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid={ADMIN.loginEmail} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid={ADMIN.loginPassword} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <Button data-testid={ADMIN.loginSubmit} type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-[#1E3A2F] hover:bg-[#1E3A2F]/90">
            {loading ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      </Card>
      <p className="mt-6 text-xs text-muted-foreground">Access is by invitation only.</p>
    </div>
  );
}
